import { Vehicle } from '@agilox/common';
import { createFeature, createReducer, on } from '@ngrx/store';
import { setVehicles } from './vehicle-filter.actions';

export interface VehiclesFilter {
	selectedVehiclesId: string[];
	selectedVehiclesFull: Vehicle[];
	machineToShow: string;
	singleVehicle: string;
}

const initialState: VehiclesFilter = {
	selectedVehiclesId: [],
	selectedVehiclesFull: undefined,
	machineToShow: undefined,
	singleVehicle: undefined,
};

const reducer = createReducer(
	initialState,
	on(setVehicles, (state, action) => ({
		...state,
		selectedVehiclesFull: action.value,
		selectedVehiclesId: action.value.map((v) => v.serial),
	}))
);

export const vehicleFilterFeature = createFeature({
	name: 'globalVehicleFilter',
	reducer,
});
